module.exports = __webpack_public_path__ + "static/Apercu-Light-4996346cd35a6d31c6bc5163cc2a1d31.eot";